{
  "labels": {
    "paste": "Pegar",
    "pasteAsPlaintext": "Pegar en tèxt brut",
    "pasteCharts": "Pegar los grafics",
    "selectAll": "Tot seleccionar",
    "multiSelect": "Apondre un element a la seleccion",
    "moveCanvas": "Desplaçar lo canabàs",
    "cut": "Talhar",
    "copy": "Copiar",
    "copyAsPng": "Copiar al quichapapièrs coma PNG",
    "copyAsSvg": "Copiar al quichapapièrs coma SVG",
    "copyText": "Copiar al quichapapièrs coma tèxt",
    "copySource": "",
    "convertToCode": "",
    "bringForward": "En avant",
    "sendToBack": "En arrièr",
    "bringToFront": "A l’endavant",
    "sendBackward": "Endarrièr",
    "delete": "Suprimir",
    "copyStyles": "Copiar los estiles",
    "pasteStyles": "Pegar los estils",
    "stroke": "Contorn",
    "background": "Rèireplan",
    "fill": "Empliment",
    "strokeWidth": "Largor de contorn",
    "strokeStyle": "Estil de contorn",
    "strokeStyle_solid": "Solide",
    "strokeStyle_dashed": "Tiret",
    "strokeStyle_dotted": "Puntilhat",
    "sloppiness": "Estil de traça",
    "opacity": "Opacitat",
    "textAlign": "Alinhament tèxt",
    "edges": "Angles",
    "sharp": "Ponchut",
    "round": "Arredonit",
    "arrowheads": "Cap de la flècha",
    "arrowhead_none": "Cap",
    "arrowhead_arrow": "Sageta",
    "arrowhead_bar": "Barra",
    "arrowhead_circle": "",
    "arrowhead_circle_outline": "",
    "arrowhead_triangle": "Triangle",
    "arrowhead_triangle_outline": "",
    "arrowhead_diamond": "",
    "arrowhead_diamond_outline": "",
    "fontSize": "Talha polissa",
    "fontFamily": "Familha de polissa",
    "addWatermark": "Apondre « Fabricat amb Excalidraw »",
    "handDrawn": "A la man levada",
    "normal": "Normala",
    "code": "Còdi",
    "small": "Pichona",
    "medium": "Mejana",
    "large": "Granda",
    "veryLarge": "Gradassa",
    "solid": "Solide",
    "hachure": "Raia",
    "zigzag": "Zigzag",
    "crossHatch": "Raia crosada",
    "thin": "Fin",
    "bold": "Espés",
    "left": "Esquèrra",
    "center": "Centre",
    "right": "Drecha",
    "extraBold": "Espesàs",
    "architect": "Arquitècte",
    "artist": "Artista",
    "cartoonist": "Dessenhaire",
    "fileTitle": "Nom del fichièr",
    "colorPicker": "Selector de color",
    "canvasColors": "Utilizada suls canabassses",
    "canvasBackground": "Rèireplan del canabàs",
    "drawingCanvas": "Zòna de dessenh",
    "layers": "Calques",
    "actions": "Accions",
    "language": "Lenga",
    "liveCollaboration": "Collaboracion en dirèct...",
    "duplicateSelection": "Duplicar",
    "untitled": "Sens títol",
    "name": "Nom",
    "yourName": "Vòstre nom",
    "madeWithExcalidraw": "Fabricat amb Excalidraw",
    "group": "Gropar la seleccion",
    "ungroup": "Desunir la seleccion",
    "collaborators": "Collaborators",
    "showGrid": "Afichar la gresilha",
    "addToLibrary": "Apondre a la bibliotèca",
    "removeFromLibrary": "Suprimir de la bibliotèca",
    "libraryLoadingMessage": "Cargament de la bibliotèca…",
    "libraries": "Percórrer las bibliotècas",
    "loadingScene": "Cargament de la scèna…",
    "align": "Alinhament",
    "alignTop": "Alinhar ennaut",
    "alignBottom": "Alinhar enbàs",
    "alignLeft": "Alinhar a esquèrra",
    "alignRight": "Alinhar a drecha",
    "centerVertically": "Centrar verticalament",
    "centerHorizontally": "Centrar orizontalament",
    "distributeHorizontally": "Distribuir orizontalament",
    "distributeVertically": "Distribuir verticalament",
    "flipHorizontal": "Virar orizontalament",
    "flipVertical": "Virar verticalament",
    "viewMode": "Mòde de vista",
    "share": "Partejar",
    "showStroke": "Mostrar lo selector de color de contorn",
    "showBackground": "Mostrar lo selector de color de fons",
    "toggleTheme": "Alternar tèma",
    "personalLib": "Bibliotèca personala",
    "excalidrawLib": "Bibliotèca Excalidraw",
    "decreaseFontSize": "Reduire talha polissa",
    "increaseFontSize": "Aumentar talha polissa",
    "unbindText": "Dessociar lo tèxte",
    "bindText": "Ligar lo tèxt al contenidor",
    "createContainerFromText": "Envelopar lo tèxte dins un contenedor",
    "link": {
      "edit": "Modificar lo ligam",
      "editEmbed": "Modificar lo ligam e l’integracion",
      "create": "Crear un ligam",
      "createEmbed": "Crear un ligam e son integracion",
      "label": "Ligam",
      "labelEmbed": "Ligam e integracion",
      "empty": "Cap de ligam pas definit"
    },
    "lineEditor": {
      "edit": "Modificar la linha",
      "exit": "Sortir de l’editor de linha"
    },
    "elementLock": {
      "lock": "Verrolhar",
      "unlock": "Desverrolhar",
      "lockAll": "Tot verrolhar",
      "unlockAll": "Tot desverrolhar"
    },
    "statusPublished": "Publicat",
    "sidebarLock": "Gardar la barra laterala dobèrta",
    "selectAllElementsInFrame": "Seleccionar totes los elements del quadre",
    "removeAllElementsFromFrame": "Tirar totes los elements d’al quadre",
    "eyeDropper": "Prendre la color a partir d’un canabàs",
    "textToDiagram": "",
    "prompt": ""
  },
  "library": {
    "noItems": "Cap d’element pas encara apondut...",
    "hint_emptyLibrary": "Seleccionatz un element d’apondre aquí, o installatz una bibliotèca del depaus public, çai-jos.",
    "hint_emptyPrivateLibrary": "Seleccionatz un element d’apondre aquí pel canabàs."
  },
  "buttons": {
    "clearReset": "Reïnicializar lo canabàs",
    "exportJSON": "Exportar en fichièr",
    "exportImage": "Exportar imatges...",
    "export": "Enregistrar dins...",
    "copyToClipboard": "Copiar al quichapapièrs",
    "save": "Salvar al fichièr actual",
    "saveAs": "Enregistrar jos",
    "load": "Dobrir",
    "getShareableLink": "Obténer lo ligam de partatge",
    "close": "Tampar",
    "selectLanguage": "Causir una lenga",
    "scrollBackToContent": "Tornar al contengut",
    "zoomIn": "Zoom avant",
    "zoomOut": "Zoom arrièr",
    "resetZoom": "Tirar lo zoom",
    "menu": "Menú",
    "done": "Acabat",
    "edit": "Modificar",
    "undo": "Anullar",
    "redo": "Restablir",
    "resetLibrary": "Reïnicializar la bibliotèca",
    "createNewRoom": "Crear sala novèla",
    "fullScreen": "Ecran complèt",
    "darkMode": "Mòde escur",
    "lightMode": "Mòde clar",
    "zenMode": "Mòde escur",
    "objectsSnapMode": "Ancorar als objèctes",
    "exitZenMode": "Sortir del mòde zen",
    "cancel": "Anullar",
    "clear": "Escafar",
    "remove": "Tirar",
    "embed": "Alternar l’integracion",
    "publishLibrary": "Publicar",
    "submit": "Enviar",
    "confirm": "Confirmar",
    "embeddableInteractionButton": "Clicar per interagir"
  },
  "alerts": {
    "clearReset": "Aquò suprimirà lo canabàs complèt. O volètz vertadièrament ?",
    "couldNotCreateShareableLink": "Creacion impossibla del ligam de partatge.",
    "couldNotCreateShareableLinkTooBig": "Creacion impossibla del ligam de partatge : la scèna es tròp granda",
    "couldNotLoadInvalidFile": "Cargament impossible d’un fichièr invalid",
    "importBackendFailed": "Importacion fracassada.",
    "cannotExportEmptyCanvas": "Impossible d’exportar los canabasses voids.",
    "couldNotCopyToClipboard": "Còpia impossibla al quichapapièrs.",
    "decryptFailed": "Deschiframent impossible de las donadas.",
    "uploadedSecurly": "Lo telecargament es estat securizat amb un chiframent del cap a la fin, significa que los servidors d’Excalidraw o que quina tèrça part que siá pòdon pas legir lo contengut.",
    "loadSceneOverridePrompt": "Cargar un dessenh extèrn remplaçarà vòstre contengut existent. Volètz contunhar ?",
    "collabStopOverridePrompt": "Arrestar la session remplaçarà vòstre precedent dessenh gardat localament. O volètz vertadièrament ?\n\n(Se volètz gardar vòstre dessenh local, tampatz simplament l’onglet del navegador a la plaça)",
    "errorAddingToLibrary": "Apondon impossible de l’element a la bibliotèca",
    "errorRemovingFromLibrary": "Supression impossibla de l’element a la bibliotèca",
    "confirmAddLibrary": "Apondrà {{numShapes}} forma(s) a vòstra bibliotèca. Confirmatz ?",
    "imageDoesNotContainScene": "Aqueste imatge sembla pas conténer cap de donadas de scèna. Avètz activat l’integracion de scèna pendent l’exportacion ?",
    "cannotRestoreFromImage": "Restauracion impossibla de la scèna a partir del fichièr imatge",
    "invalidSceneUrl": "Importacion impossibla de la scèna a partir de l’URL provesida. Es siá mal formatada o siá conten pas cap de donada JSON Excalidraw valida.",
    "resetLibrary": "Aquò suprimirà vòstra bibliotèca. O volètz vertadièrament ?",
    "removeItemsFromsLibrary": "Suprimir {{count}} element(s) de la bibliotèca ?",
    "invalidEncryptionKey": "La clau de chiframent deu conténer 22 caractèrs. La collaboracion en dirèct es desactivada.",
    "collabOfflineWarning": "Cap de connexion pas disponibla.\nVòstras modificacions seràn pas salvadas !"
  },
  "errors": {
    "unsupportedFileType": "Tipe de fichièr pas pres en carga.",
    "imageInsertError": "Insercion d’imatge impossibla. Tornatz ensajar mai tard...",
    "fileTooBig": "Fichièr tròp pesuc. La talha maximala autorizada es {{maxSize}}.",
    "svgImageInsertError": "Insercion d’imatge SVG impossibla. Las balisas SVG semblan invalidas.",
    "failedToFetchImage": "Fracàs de la recuperacion de l’imatge.",
    "invalidSVGString": "SVG invalid.",
    "cannotResolveCollabServer": "Connexion impossibla al servidor collab. Mercés de recargar la pagina e tornar ensajar.",
    "importLibraryError": "Impossible de cargar la bibliotèca",
    "collabSaveFailed": "",
    "collabSaveFailed_sizeExceeded": "",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "",
      "line2": "",
      "line3": "",
      "line4": ""
    },
    "libraryElementTypeError": {
      "embeddable": "",
      "iframe": "",
      "image": ""
    },
    "asyncPasteFailedOnRead": "Empegatge impossible (lectura impossibla a partir del quichapapièrs).",
    "asyncPasteFailedOnParse": "Empegatge impossible.",
    "copyToSystemClipboardFailed": "Còpia impossibla al quichapapièrs."
  },
  "toolBar": {
    "selection": "Seleccion",
    "image": "Inserir imatge",
    "rectangle": "Rectangle",
    "diamond": "Lausange",
    "ellipse": "Ellipsa",
    "arrow": "Sageta",
    "line": "Linha",
    "freedraw": "Dessenhar",
    "text": "Tèxt",
    "library": "Bibliotèca",
    "lock": "Mantenir activa l’aisina aprèp dessenhar",
    "penMode": "Mòde estilo - empachar lo contact",
    "link": "Apondre/Actualizar lo ligam per una fòrma seleccionada",
    "eraser": "Goma",
    "frame": "Esplech quadre",
    "magicframe": "",
    "embeddable": "Integracion Web",
    "laser": "Puntador laser",
    "hand": "Man (aisina de desplaçament de la vista)",
    "extraTools": "Mai d’aisinas",
    "mermaidToExcalidraw": "De Mermaid cap a Excalidraw",
    "magicSettings": ""
  },
  "headings": {
    "canvasActions": "Accions del canabàs",
    "selectedShapeActions": "Accions per la forma seleccionada",
    "shapes": "Formas"
  },
  "hints": {
    "canvasPanning": "",
    "linearElement": "Clicatz per començar mantun punt, lisatz per una sola linha",
    "freeDraw": "Clicatz e lisatz, relargatz un còp acabat",
    "text": "Astúcia : podètz tanben apondre de tèxt en doble clicant ont que siá amb l’aisina de seleccion",
    "embeddable": "",
    "text_selected": "Clicatz dos còps o quichatz ENTRADA per modificar lo tèxt",
    "text_editing": "Quichatz ESCAPAR o CtrlOrCmd+ENTRADA per acabar la modificacion",
    "linearElementMulti": "Clicatz sul darrièr punt o quichatz Ecap o Entrada per acabar",
    "lockAngle": "Podètz restrénger l’angle en mantenent MAJ",
    "resize": "Podètz servar las proporcions en mantenent la tòca MAJ pendent lo redimensionament,\nmantenètz la tòca ALT per redimensionar a partir del centre",
    "resizeImage": "Podètz retalhar liurament en quichant CTRL,\nquichatz ALT per retalhar a partir del centre",
    "rotate": "Podètz restrénger los angles en mantenent MAJ pendent la rotacion",
    "lineEditor_info": "Tenètz quichat Ctrl o Cmd e doble clic o quichatz Ctrl o Cmd + Entrada per modificar los ponches",
    "lineEditor_pointSelected": "Quichar Suprimir per tirar lo(s) punt(s),\nCtrlOCmd+D per duplicar, o lisatz per desplaçar",
    "lineEditor_nothingSelected": "Seleccionar un punt d’editar (manténer Maj. per ne seleccionar mantun),\no manténer Alt e clicar per n’apondre de novèls",
    "placeImage": "Clicatz per plaçar l’imatge, o clicatz e lisatz per definir sa talha manualament",
    "publishLibrary": "Publicar vòstra pròpria bibliotèca",
    "bindTextToElement": "Quichatz Entrada per apondre de tèxte",
    "deepBoxSelect": "Gardar CtrlOCmd per una seleccion gropada e empachar lo desplaçament",
    "eraserRevert": "Tenètz quichat Alt per anullar los elements marcats per supression",
    "firefox_clipboard_write": "",
    "disableSnapping": ""
  },
  "canvasError": {
    "cannotShowPreview": "Afichatge impossible de l’apercebut",
    "canvasTooBig": "Lo canabàs pòt èsser tròp grand.",
    "canvasTooBigTip": "Astúcia : ensajatz de sarrar los elements mai alonhats."
  },
  "errorSplash": {
    "headingMain": "Una error s’es producha. Ensajatz <button>recargament de la pagina.</button>",
    "clearCanvasMessage": "Se recargar fonciona pas, ensajatz <button>d’escafar los canabasses.</button>",
    "clearCanvasCaveat": " Menarà a una pèrda del trabalh ",
    "trackedToSentry": "Error amb l’identificant {{eventId}} es estada enregistrada sus nòstre sistèma.",
    "openIssueMessage": "Èrem plan prudents per inclure pas d’informacions de la scèna vòstra sus l’error. Se vòstra scèna es pas privada, volgatz considerar de perseguir sus nòstre <button>traçadors d’avarias.</button> Volgatz inclure las informacions çai-jos en las copiant e pegant a l’issue GitHub.",
    "sceneContent": "Contengut de la scèna :"
  },
  "roomDialog": {
    "desc_intro": "Podètz convidar lo monde a vòstra scèna actuala per participar amb vos.",
    "desc_privacy": "Vos en fagatz pas, la session utiliza lo chiframent del cap a la fin, çò que dessenetz demorarà privat. Mai nòstres servidors poiràn pas veire vòstra creacion.",
    "button_startSession": "Començar la session",
    "button_stopSession": "Arrestar la session",
    "desc_inProgressIntro": "La session de collaboracion es ara en cors.",
    "desc_shareLink": "Partejatz aqueste ligam amb lo monde amb qui volètz collaborar :",
    "desc_exitSession": "Arrestar la session vos desconnectarà de la sala, mas poiretz contunhar de trabalhar a la scèna, en local. Notatz qu’aquò afectarà pas los autres, e poiràn collaborar a lor version.",
    "shareTitle": "Rejonhètz una session collaborativa sus Excalidraw"
  },
  "errorDialog": {
    "title": "Error"
  },
  "exportDialog": {
    "disk_title": "Salvar al disc",
    "disk_details": "Exportar las donadas de la scèna cap a un fichièr que podètz importar mai tard.",
    "disk_button": "Salvar al fichièr",
    "link_title": "Ligam de partejar",
    "link_details": "Exportar coma un ligam de lectura sola.",
    "link_button": "Exportar en ligam",
    "excalidrawplus_description": "Enregistrar la scèna dins vòstre espaci de trabalh Excalidraw+.",
    "excalidrawplus_button": "Exportar",
    "excalidrawplus_exportError": "Export impossibla cap a Excalidraw+ pel moment..."
  },
  "helpDialog": {
    "blog": "Legir nòstre blog",
    "click": "clic",
    "deepSelect": "Seleccion prigonda",
    "deepBoxSelect": "Seleccionar demest un grop e empacha lo desplaçament",
    "curvedArrow": "Sageta corba",
    "curvedLine": "Linha corba",
    "documentation": "Documentacion",
    "doubleClick": "doble clic",
    "drag": "lisar",
    "editor": "Editor",
    "editLineArrowPoints": "",
    "editText": "Modificar lo tèxte / apondre etiqueta",
    "github": "Problèma trobat ? Senhalatz-lo",
    "howto": "Seguissètz nòstras guidas",
    "or": "o",
    "preventBinding": "Empachar la fixacion de sagetas",
    "tools": "Aisinas",
    "shortcuts": "Acorchis clavièr",
    "textFinish": "Terminar l’edicion (editor de tèxt)",
    "textNewLine": "Apondre linha novèl (editor de tèxt)",
    "title": "Ajuda",
    "view": "Vista",
    "zoomToFit": "Zoomar per veire totes los elements",
    "zoomToSelection": "Zoomar la seleccion",
    "toggleElementLock": "Verrolhar/Desverrolhar la seleccion",
    "movePageUpDown": "Desplaçar la pagina ennaut/enbàs",
    "movePageLeftRight": "Desplaçar la pagina a esquèrra/drecha"
  },
  "clearCanvasDialog": {
    "title": "Escafar canabàs"
  },
  "publishDialog": {
    "title": "Publicar la bibliotèca",
    "itemName": "Nom de l’element",
    "authorName": "Nom de l’autor",
    "githubUsername": "Nom d’utilizaire GitHub",
    "twitterUsername": "Nom d’utilizaire Twitter",
    "libraryName": "Nom de la bibliotèca",
    "libraryDesc": "Descripcion de la bibliotèca",
    "website": "Site web",
    "placeholder": {
      "authorName": "Vòstre nom o nom d’utilizaire",
      "libraryName": "Nom de vòstra bibliotèca",
      "libraryDesc": "Descripcion de vòstra bibliotèca per ajudar lo monde a comprendre son utilizacion",
      "githubHandle": "GitHub handle(opcional), per poder modificar la bibliotèca un còp enviada per repassa",
      "twitterHandle": "Nom d’utilizaire Twitter (opcional), per saber qual mercejar quand ne parlam sus Twitter",
      "website": "Ligam cap a vòstre site web personal o endacòm mai (opcional)"
    },
    "errors": {
      "required": "Requerit",
      "website": "Picatz una URL valida"
    },
    "noteDescription": "Enviatz vòstra bibliotèca per èsser compresa al <link>repertòri public de bibliotèca</link>per que los autres l’utilizen dins lor dessenhs.",
    "noteGuidelines": "Qualqu’un deu aprovar la bibliotèca manualament per començar. Volgatz legir las <link>linhas directrises</link> abans de sometre. Vos farà mestièr un compte GitHub per comunicar e realizar de modificacions se demandadas, mas es pas complètament obligatòri.",
    "noteLicense": "En sometent, acceptatz que la bibliotèca siá publicada sota la <link>Licéncia MIT, </link>que significa en brèu que qual que siá pòt l’utilizar sens cap de restriccion.",
    "noteItems": "Cada element de bibliotèca deu aver un nom pròpri per èsser filtrable. Los elements de bibliotèca seguentas seràn incluses :",
    "atleastOneLibItem": "Volgatz seleccionar almens un element de bibliotèca per començar",
    "republishWarning": "Nòta : d’unes elements seleccionats son marcats ja coma publicats/enviats. Deuriatz sonque tornar enviar los elements pendent l’actualizacion d’una bibliotèca existenta o un mandadís."
  },
  "publishSuccessDialog": {
    "title": "Bibliotèca somesa",
    "content": "Mercés {{authorName}}. Vòstre bibliotèca es estada somesa per repassa. Podètz seguir l’avançament<link>aquí</link>"
  },
  "confirmDialog": {
    "resetLibrary": "Reïnicializar la bibliotèca",
    "removeItemsFromLib": "Tirar los elements seleccionats de la bibliotèca"
  },
  "imageExportDialog": {
    "header": "Exportar imatges",
    "label": {
      "withBackground": "Rèireplan",
      "onlySelected": "Seleccion sonque",
      "darkMode": "Mòde escur",
      "embedScene": "Embarcar la scèna",
      "scale": "Escala",
      "padding": "Espaçament"
    },
    "tooltip": {
      "embedScene": ""
    },
    "title": {
      "exportToPng": "Exportar en PNG",
      "exportToSvg": "Exportar en SVG",
      "copyPngToClipboard": "Copiar PNG al quichapapièrs"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "Copiar al quichapapièrs"
    }
  },
  "encrypted": {
    "tooltip": "Vòstres dessenhs son chifrats del cap a la fin en consequéncia los servidors d’Excalidraw los veiràn pas jamai.",
    "link": "Article de blòg sul chiframent del cap a la fin dins Excalidraw"
  },
  "stats": {
    "angle": "Angle",
    "element": "Element",
    "elements": "Elements",
    "height": "Nautor",
    "scene": "Scèna",
    "selected": "Seleccionat",
    "storage": "Emmagazinatge",
    "title": "Estatisticas pels nerds",
    "total": "Total",
    "version": "Version",
    "versionCopy": "Clicar per copiar",
    "versionNotAvailable": "Version pas disponibla",
    "width": "Largor"
  },
  "toast": {
    "addedToLibrary": "Apondut a la bibliotèca",
    "copyStyles": "Estiles copiats.",
    "copyToClipboard": "Copiats al quichapapièrs.",
    "copyToClipboardAsPng": "{{exportSelection}} copiat coma PNG ({{exportColorScheme}})",
    "fileSaved": "Fichièr enregistrat.",
    "fileSavedToFilename": "Enregistrat jos {filename}",
    "canvas": "canabàs",
    "selection": "seleccion",
    "pasteAsSingleElement": "",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": ""
  },
  "colors": {
    "transparent": "Transparéncia",
    "black": "Negre",
    "white": "Blanc",
    "red": "Roge",
    "pink": "Ròse",
    "grape": "Bordèu",
    "violet": "Violet",
    "gray": "Gris",
    "blue": "Blau",
    "cyan": "Cian",
    "teal": "Sarcèla",
    "green": "Verd",
    "yellow": "Jaune",
    "orange": "Irange",
    "bronze": "Bronze"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "Totas las donadas son enregistradas dins vòstre navegador.",
      "center_heading_plus": "Voliatz puslèu utilizar Excalidraw+ a la plaça ?",
      "menuHint": "Exportar, preferéncias, lengas, ..."
    },
    "defaults": {
      "menuHint": "Exportar, preferéncias, e mai...",
      "center_heading": "Diagram. Tot. Simplament.",
      "toolbarHint": "Prenètz un esplech e començatz de dessenhar !",
      "helpHint": "Acorchis e ajuda"
    }
  },
  "colorPicker": {
    "mostUsedCustomColors": "Colors personalizadas mai utilizadas",
    "colors": "Colors",
    "shades": "Nuanças",
    "hexCode": "Còdi exadecimal",
    "noShades": "Cap de nuança pas disponibla per aquesta color"
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "Exportar coma imatge",
        "button": "Exportar coma imatge",
        "description": ""
      },
      "saveToDisk": {
        "title": "Salvar al disc",
        "button": "Salvar al disc",
        "description": "Exportar las donadas de la scèna cap a un fichièr que podètz importar mai tard."
      },
      "excalidrawPlus": {
        "title": "Excalidraw+",
        "button": "Exportar dins Excalidraw+",
        "description": "Enregistrar la scèna dins vòstre espaci de trabalh Excalidraw+."
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "Cargar d’un fichièr",
        "button": "Cargar d’un fichièr",
        "description": ""
      },
      "shareableLink": {
        "title": "Cargar d’un ligam",
        "button": "Remplaçar mon contengut",
        "description": ""
      }
    }
  },
  "mermaid": {
    "title": "De Mermaid cap a Excalidraw",
    "button": "Inserir",
    "description": "",
    "syntax": "Sintaxi Mermaid",
    "preview": "Apercebut"
  }
}
